import styled from 'styled-components';

export const Trapezoid = styled.div`
  transform: skew(-20deg);
  background: var(--background, var(--c-score-high));
  padding: var(--half-unit) var(--double-unit);

  & > * {
    transform: skew(20deg);
  }
`;
